/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

class SortInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        types: [
          {
            name: 'created_at',
            title: 'По дате добавления'
          },
          {
            name: 'updated_at',
            title: 'По дате изменения'
          },
          {
            name: 'cost_execution',
            title: 'По цене'
          },
          {
            name: 'rating',
            title: 'По рейтингу'
          },
          {
            name: 'stat_finished_execs',
            title: 'Оплаченным заявкам'
          }
        ]
      }
    };
  }

  getOrderBy = () =>
    this.props.selectQueryParams.sort.includes('-') ? '-' : '';
  getSortName = () => this.props.selectQueryParams.sort.replace(/-/g, '');
  getSortTitle = () => {
    const type = this.state.sort.types.find(v => v.name === this.getSortName());
    return type ? type.title : '-';
  };

  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default border-b">
        <div className="panel-body">
          <div className="form-group m-b-0">
            <div className="dropdown">
              <button
                className="btn btn-sm btn-block btn-default dropdown-toggle"
                title="По дате добавления"
                type="button"
                id="GroupFilter_sort"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                <i
                  className={`fa fa-fw ${
                    this.getOrderBy()
                      ? 'fa-sort-amount-desc'
                      : 'fa-sort-amount-asc'
                  }`}
                />
                {this.getSortTitle()}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="GroupFilter_sort"
              >
                {this.state.sort.types.map(item => (
                  <li
                    key={`tasksTypeSortItem-${item.name}`}
                    className={
                      this.props.selectQueryParams.sort.includes(item.name)
                        ? 'active'
                        : ''
                    }
                  >
                    <a
                      href=""
                      onClick={e => {
                        e.preventDefault();
                        this.changeQueryParams({
                          sort: `${this.getOrderBy()}${item.name}`
                        });
                      }}
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
                <li role="separator" className="divider" />
                <li className={this.getOrderBy() !== '-' ? 'active' : ''}>
                  <a
                    href=""
                    onClick={e => {
                      e.preventDefault();
                      this.changeQueryParams({
                        sort: this.getSortName()
                      });
                    }}
                  >
                    <i className="fa fa-fw fa-sort-amount-asc" /> по возростанию
                  </a>
                </li>
                <li className={this.getOrderBy() === '-' ? 'active' : ''}>
                  <a
                    href=""
                    onClick={e => {
                      e.preventDefault();
                      this.changeQueryParams({
                        sort: `-${this.getSortName()}`
                      });
                    }}
                  >
                    <i className="fa fa-fw fa-sort-amount-desc" />
                    по убыванию
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SortInputs.propTypes = {
  selectQueryParams: PropTypes.shape({
    sort: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});
const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SortInputs)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/SortInputs/SortInputs.js